import React, { FC, MouseEventHandler, useRef } from 'react';
import { useSlideIcons } from '@/util/slideIcons.ts';
import { useNavigation } from '@/navigation/NavigationContex.ts';
import { useUiEvent } from '@/util/useUiEvent.ts';
import { isNil } from 'ramda';

export const Navigation: FC = () => {
  const { navControl, currentSlide } = useNavigation();
  const { hasNext, isValid, hasPrev } = navControl;
  const { handleUiEvent } = useUiEvent();

  const { prevLabel, prevIcon, nextLabel, nextIcon } = useSlideIcons(currentSlide!);

  const prevBtnRef = useRef<HTMLButtonElement | null>(null);
  const nextBtnRef = useRef<HTMLButtonElement | null>(null);

  const handlePrev: MouseEventHandler = (_e) => {
    handleUiEvent({
      type: 'nav',
      target: 'prev',
    });
  };

  const handleNext: MouseEventHandler = async () => {
    if (!isNil(currentSlide?.next?.uievent)) {
      handleUiEvent(currentSlide.next.uievent);
    }
  };

  const nextVisible = currentSlide?.isNextButtonVisible !== false;

  const onNavKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    const key = e.key;
    if (key === 'ArrowLeft' || key === 'ArrowUp') {
      if (prevBtnRef.current) {
        e.preventDefault();
        prevBtnRef.current.focus();
      }
    } else if (key === 'ArrowRight' || key === 'ArrowDown') {
      if (nextBtnRef.current) {
        e.preventDefault();
        nextBtnRef.current.focus();
      }
    }
  };

  return (
    <div className="Navigation" onKeyDown={onNavKeyDown}>
      {hasPrev && (
        <button
          className="nav-prev"
          onClick={handlePrev}
          ref={prevBtnRef}
          tabIndex={hasNext && isValid && nextVisible ? 1 : 0}
        >
          <i className={prevIcon} />
          <span className="d-sm-inline">{prevLabel}</span>
        </button>
      )}

      {hasNext && isValid && nextVisible && (
        <button className="nav-next" onClick={handleNext} ref={nextBtnRef} tabIndex={0}>
          {nextLabel}
          <i className={nextIcon} />
        </button>
      )}
    </div>
  );
};
